<template>
    <header class="section register-info py-5">
        <h1 class="logo has-text-centered">
            <Logo />
        </h1>
        <div v-if="title" class="bienvenido">
            <div class="bienvenido-title">
                <h2 class="is-size-3 has-text-weight-bold mb-2">{{ title }}</h2>
                <p class="has-text-weight-light has-text-centered" >{{ text }}</p>
            </div>
        </div>
    </header>
</template>

<script>
import Logo from "@/components/svg/Logo.vue";

export default {
    name: "Header",
    components: { Logo },
    props: {
        title: {
            type: String,
            default: "¡Bienvenido!",
        },
        text: {
            type: String,
            default:
                "A la plataforma para gestionar y planificar el flujo de caja de tu negocio.",
        },
    },
};
</script>
